export const FAILED_REQUEST = "AUTH_FAILED_REQUEST";
export const LOADING_REQUEST = "AUTH_LOADING_REQUEST";

export const LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";

export const LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS";
